import { Link } from "gatsby"
import styled from "styled-components";


const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: normal;
  color: #2F2B27;
`;

const Wrapper =styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 80%;
    align-items: center;
    @media (max-width: 768px) {
        width: 100%;
      }
`;

const Splash = styled.div`
    display: flex;
    align-items: center;
    height: 240px;
    width: -webkit-fill-available;
    object-fit: cover;
`;

const Pic = styled.img`
    margin:0;
    max-height: 240px;
    width: -webkit-fill-available;
    object-fit: cover;
`;

const SplashTxt =styled.div`
  color: #fff;
  font-size: 48px;
  letter-spacing: 1px;
  font-weight: 600;
  position: absolute;
  padding-left: 50px;
`;

const Title = styled.div`
    display: flex;
    align-items: center;
    font-size: 34px;
    font-weight: bold;
    width: 100%;
    margin-top: 25px;
    margin-bottom: 25px;
    text-transform: uppercase;
    line-height: 1;
}
`;

const Para = styled.div`
    font-size: 18px;
    width: 100%;
`;

const Bracket = styled.img`
  margin:0;
  margin-right: -10px;
  min-height: 100px;
`;

const InfoCon = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 50px;
    @media (max-width: 768px) {
        margin: 0px;
        padding: 25px;
      }
`;

export {
    Container,
    Wrapper,
    Splash,
    Pic,
    SplashTxt,
    Title,
    Para,
    Bracket,
    InfoCon,

}